/**
 * Instantiate new toast
 *
 * @param {string} variant - Sets the type of toast. [success, error]
 * @param {string } text - Sets the text to be shown.
 * @param {number} duration - Sets the duration of visibility in milliseconds. Default is set to 4000 milliseconds.
 *
 * TODO: add ability to accept an object as a parameter and add option to remove button
 */
export const setToast = function (variant, text, duration = 4000, position = 'bottom-left') {
    // GENERATE ID
    const generateId = () => Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    const id = generateId() + generateId() + '-' + generateId();
    // CHECK FOR EXISTING
    if (document.querySelector('.hds-m-toast'))
        document.querySelector('.hds-m-toast').remove();
    const successIcon = '<span class="fas fa-check-circle"></span>';
    const dangerIcon = '<span class="fas fa-exclamation-triangle"></span>';
    const str = `<div class="hds-m-toast hds-m-toast--${variant} hds-m-toast--${position}" id="${id}">
		<span class="hds-a-icon hds-a-icon--tall hds-m-toast__icon">
			${variant == 'success' ? successIcon : dangerIcon}
		</span>
		<span class="hds-m-toast__text">${text}</span>
		<button type="button" class="hds-a-button hds-a-button--inverted hds-a-button--compact hds-m-toast__button">Dismiss</button>
	</div>`;
    // APPEND TO DOM
    const parser = new DOMParser();
    const html = parser.parseFromString(str, 'text/html');
    document.body.append(html.body.firstChild);
    // ADD BUTTON EVENT LISTENER
    document
        .querySelector('.hds-m-toast__button')
        .addEventListener('click', (event) => event.target.parentElement.remove());
    // SET AUTO REMOVE
    if (duration !== 0) {
        // 0 == infinite
        setTimeout(() => {
            if (document.getElementById(id))
                document.getElementById(id).remove();
        }, duration);
    }
};

//# sourceMappingURL=toast-utils.js.map
